// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vue-slider-rail-bidding-primary .vue-slider-marks{background:var(--v-primary-base)}.custom-slider-dot{background-color:var(--v-secondary-base);border-radius:0;height:100%;position:-50px;transition:all .3s;width:100%}.custom-slider-dot:hover{transform:rotate(45deg)}.custom-slider-dot.focus{border-radius:50%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
